import React from "react";
import DeleteInstallerContainer from "../../containers/installers/DeleteInstallerContainer";
import Modal from "../../components/Modal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Button, Grid, Box, Typography } from "@material-ui/core";

const DeleteInstaller = ({ handleClose, open, profile }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Modal
      fullScreen={matches}
      open={open}
      onClose={handleClose}
      title={t("delete_installer.title")}
    >
      {profile ? (
        <DeleteInstallerContainer installer={profile} onClose={handleClose}>
          {({ onSubmit, installer }) => (
            <Box
              mt={1}
              boxShadow={{ xs: 0, sm: 2 }}
              display="flex"
              flexDirection="column"
              p={2}
            >
              <Box mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography color="textPrimary">
                      {t("delete_installer.text")}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => onSubmit(installer)}
                    >
                      {t("delete_installer.button_text")}
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </DeleteInstallerContainer>
      ) : null}
    </Modal>
  );
};

export default DeleteInstaller;
